import { useState, useEffect, useRef } from "react";
import { Container, Row } from "react-bootstrap";
import "animate.css";
import profile from "../assets/img/myImg2.png";

export const Banner = () => {
  const [animated, setAnimated] = useState(false);
  const textRef = useRef(null);
  // const [loopNum, setLoopNum] = useState(0);
  // const [isDeleting, setIsDeleting] = useState(false);
  // const [text, setText] = useState("");
  // const [delta, setDelta] = useState(300 - Math.random() * 100);
  // const [index, setIndex] = useState(1);
  // const toRotate = ["Web Developer", "Web Designer", "UI/UX Designer"];
  // const period = 2000;

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setAnimated(true);
        }
      },
      { threshold: 0.1 },
    );

    if (textRef.current) {
      observer.observe(textRef.current);
    }

    return () => observer.disconnect();
  }, []);
  // useEffect(() => {
  //   // let ticker = setInterval(() => {
  //   //   tick();
  //   // }, delta);
  //   // return () => {
  //   //   clearInterval(ticker);
  //   // };
  // }, [text]);

  // const tick = () => {
  //   let i = loopNum % toRotate.length;
  //   let fullText = toRotate[i];
  //   let updatedText = isDeleting
  //     ? fullText.substring(0, text.length - 1)
  //     : fullText.substring(0, text.length + 1);

  //   setText(updatedText);

  //   if (isDeleting) {
  //     setDelta((prevDelta) => prevDelta / 2);
  //   }

  //   if (!isDeleting && updatedText === fullText) {
  //     setIsDeleting(true);
  //     setIndex((prevIndex) => prevIndex - 1);
  //     setDelta(period);
  //   } else if (isDeleting && updatedText === "") {
  //     setIsDeleting(false);
  //     setLoopNum(loopNum + 1);
  //     setIndex(1);
  //     setDelta(500);
  //   } else {
  //     setIndex((prevIndex) => prevIndex + 1);
  //   }
  // };

  //   return (
  //     <section className="banner" id="home">
  //       <Container>
  //         <Row
  //           style={{
  //             // alignItems: "center",
  //             justifyContent: "center",
  //           }}
  //         >
  //           <Col
  //             md={6}
  //             style={{
  //               width: "54vw",
  //             }}
  //           >
  //             <div
  //               style={{
  //                 textAlign: "center",
  //                 flexDirection: "column",
  //                 alignItems: "center",
  //                 display: "flex",
  //               }}
  //             >
  //               <div style={{ marginTop: 30 }}>
  //                 <img
  //                   src={profile}
  //                   alt="User Profile"
  //                   style={{
  //                     width: 480,
  //                     height: 550,
  //                   }}
  //                 />
  //               </div>

  //               <p1>{`Hello Everyone!`} </p1>
  //               <p>
  //                 I’m<p2>{` Fazi `}</p2>, and I am experienced Video Editor from
  //                 past
  //                 <p2>{` 5 years`}</p2>.
  //               </p>
  //               <p>
  //                 I start my journey as a junior editor and become professional in
  //                 just 7-8 months. I edit for all kind of social media platform
  //                 like Facebook, Instagram, TikTok, and specially YouTube. I
  //                 personally complete more then 2000 projects with 100s of
  //                 clients. My Firsthand experience as a YouTube Video Editor. I
  //                 did all format of YouTube videos like Documentaries, Podcasts,
  //                 Stories, Faceless, Talking-Head, news and many.
  //               </p>
  //               {/* <button onClick={() => console.log("connect")}>
  //                 Let’s Connect <ArrowRightCircle size={25} />
  //               </button> */}
  //             </div>
  //           </Col>
  //         </Row>
  //       </Container>
  //     </section>
  //   );
  // };
  return (
    <section className="banner" id="home">
      <Container>
        <Row className="justify-content-center">
          <div className="banner-content" ref={textRef}>
            <div className="animated-image">
              <img
                src={profile}
                alt="User Profile"
                className={
                  animated
                    ? "animate__animated animate__fadeInUp"
                    : "pre-animate"
                }
              />
            </div>

            <div className="text-animation-group">
              <h2
                className={
                  animated
                    ? "animate__animated animate__fadeInDown"
                    : "pre-animate"
                }
              >
                Hello Everyone!
              </h2>

              <p
                className={
                  animated
                    ? "animate__animated animate__fadeInLeft"
                    : "pre-animate"
                }
              >
                I'm{" "}
                <span className="highlight animate__animated animate__pulse animate__infinite">
                  Fazi
                </span>
                , and I am experienced Video Editor from past{" "}
                <span className="highlight animate__animated animate__pulse animate__infinite">
                  5 years.
                </span>
              </p>

              <p
                className={
                  animated
                    ? "animate__animated animate__fadeInRight"
                    : "pre-animate"
                }
              >
                I start my journey as a junior editor and become professional in
                just 7-8 months. I edit for all kind of social media platform
                like Facebook, Instagram, TikTok, and specially YouTube. I
                personally complete more then 2000 projects with 100s of
                clients. My Firsthand experience as a YouTube Video Editor. I
                did all format of YouTube videos like Documentaries, Podcasts,
                Stories, Faceless, Talking-Head, news and many.
              </p>
            </div>
          </div>
        </Row>
      </Container>
    </section>
  );
};
